import {
  change_password,
  dashboard,
  options,
  download,
  attendance_login,
  attendance_logout,
  password_recovery
} from "components/Routes/AppRoutes";
import { SECTIONS, GROUPS, MODULES, MODULE_BY_KEY } from "components/Routes/moduleCatalog";

// Las claves de módulo de la cuenta las entrega el back al iniciar sesión (modulos_cuenta)
// y se guardan en localStorage. Qué módulos ve cada usuario, cargo o área se define en el back.
const readModuleKeys = () => {
  try {
    const keys = JSON.parse(localStorage.getItem("modulos"));
    return Array.isArray(keys) ? keys : [];
  } catch (e) {
    localStorage.removeItem("modulos");
    return [];
  }
};

// Una sesión abierta antes de existir las claves no tiene "modulos": se pide iniciar sesión de nuevo.
const isSessionWithoutModules = () =>
  localStorage.getItem("access") !== null &&
  localStorage.getItem("modulos") === null &&
  window.location.pathname.startsWith("/admin");

export const buildRoutes = (moduleKeys) => {
  const selected = new Set(moduleKeys);
  moduleKeys
    .filter((key) => !MODULE_BY_KEY[key])
    .forEach((key) => console.warn(`Módulo desconocido ignorado: ${key}`));

  const sections = {};
  const groups = {};
  MODULES.filter((module) => selected.has(module.key)).forEach((module) => {
    if (!sections[module.section]) {
      sections[module.section] = { ...SECTIONS[module.section], views: [] };
    }
    const section = sections[module.section];
    if (module.group) {
      if (!groups[module.group]) {
        groups[module.group] = { ...GROUPS[module.group], views: [] };
        section.views.push(groups[module.group]);
      }
      groups[module.group].views.push(module.route);
    } else if (module.route) {
      section.views.push(module.route);
    }
  });

  return [
    ...Object.keys(SECTIONS).filter((id) => sections[id]).map((id) => sections[id]),
    attendance_login,
    password_recovery,
    attendance_logout,
    dashboard,
    change_password,
    options,
    download,
  ];
};

if (isSessionWithoutModules()) {
  localStorage.clear();
  window.location.href = "/Login";
}

const dashRoutes = buildRoutes(readModuleKeys());

export default dashRoutes;
